var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxoutlinedataUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.8,11.2C5.8,11.2,5.7,11.2,5.8,11.2 C4.2,11.1,3.1,10,3.1,8.5c0-1.5,1.2-2.7,2.7-2.7S8.5,7,8.5,8.5C8.5,10,7.4,11.1,5.8,11.2C5.9,11.2,5.9,11.2,5.8,11.2 C5.9,11.2,5.8,11.2,5.8,11.2z M4.6,8.5c0,0.6,0.5,1.2,1.2,1.2c0,0,0.1,0,0.1,0C6.5,9.7,7,9.1,7,8.5c0-0.7-0.5-1.2-1.2-1.2 S4.6,7.8,4.6,8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.6,17.3c-0.8-0.6-1.3-1.4-1.3-2.2 s0.5-1.7,1.3-2.2c1.8-1.2,4.6-1.2,6.3,0c0.8,0.6,1.3,1.4,1.3,2.2c0,0.9-0.5,1.7-1.3,2.2c-0.9,0.6-2,0.9-3.2,0.9 S3.5,17.9,2.6,17.3z M2.8,15.1c0,0.4,0.2,0.7,0.7,1c1.3,0.9,3.4,0.9,4.7,0c0.4-0.3,0.7-0.6,0.7-1c0-0.4-0.2-0.7-0.7-1 c-1.3-0.9-3.4-0.9-4.7,0C3,14.4,2.8,14.7,2.8,15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2,12c0-1.5,1.2-2.8,2.8-2.8s2.8,1.2,2.8,2.8s-1.2,2.8-2.8,2.8S17.2,13.5,17.2,12z M18.8,12 c0,0.7,0.6,1.2,1.2,1.2s1.2-0.6,1.2-1.2s-0.6-1.2-1.2-1.2S18.8,11.3,18.8,12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2,4c0-1.5,1.2-2.8,2.8-2.8 s2.8,1.2,2.8,2.8S21.5,6.8,20,6.8S17.2,5.5,17.2,4z M18.8,4c0,0.7,0.6,1.2,1.2,1.2s1.2-0.6,1.2-1.2S20.7,2.8,20,2.8 S18.8,3.3,18.8,4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2,20c0-1.5,1.2-2.8,2.8-2.8 s2.8,1.2,2.8,2.8s-1.2,2.8-2.8,2.8S17.2,21.5,17.2,20z M18.8,20c0,0.7,0.6,1.2,1.2,1.2s1.2-0.6,1.2-1.2s-0.6-1.2-1.2-1.2 S18.8,19.3,18.8,20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8,12c0-0.4-0.3-0.8-0.8-0.8h-7c-0.4,0-0.8,0.3-0.8,0.8s0.3,0.8,0.8,0.8h7C18.4,12.8,18.8,12.4,18.8,12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,19.2h-1.2c-1.6,0-2.2-0.7-2.2-2.2V7c0-1.6,0.7-2.2,2.2-2.2H18c0.4,0,0.8-0.3,0.8-0.8S18.4,3.2,18,3.2 h-1.2c-1.5,0-2.6,0.5-3.2,1.5C13.2,5.4,13,6.1,13,7v10c0,0.9,0.2,1.6,0.5,2.2c0.6,1,1.7,1.5,3.2,1.5H18c0.4,0,0.8-0.3,0.8-0.8 S18.4,19.2,18,19.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxoutlinedataUser);
export default __webpack_public_path__ + "static/media/vuesaxoutlinedata-user.87ce37168e1ed4119f08d765d959f351.svg";
export { ForwardRef as ReactComponent };